import { render, staticRenderFns } from "./DevConfig.vue?vue&type=template&id=618e2377&scoped=true"
import script from "./DevConfig.vue?vue&type=script&lang=js"
export * from "./DevConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618e2377",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('618e2377')) {
      api.createRecord('618e2377', component.options)
    } else {
      api.reload('618e2377', component.options)
    }
    module.hot.accept("./DevConfig.vue?vue&type=template&id=618e2377&scoped=true", function () {
      api.rerender('618e2377', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/clientManage/coupons/dialogs/DevConfig.vue"
export default component.exports